import { assign, createMachine, InterpreterFrom, StateConfig, StateFrom } from 'xstate'

import { OnboardingData, OnboardingPractitionerUserMetadata } from '../types'

export type OnboardPractitionerContext = OnboardingData &
  OnboardingPractitionerUserMetadata & { customerId?: string }

export type OnboardPractitionerEvent =
  | { type: 'CONTINUE' }
  | { type: 'RESTORE' }
  | { type: 'UPDATE_FIELDS'; data: Partial<OnboardPractitionerContext> }

type OnboardPractitionerState = {
  value: 'initial' | 'createAccount' | 'invalid' | 'complete'
  context: OnboardPractitionerContext
}

export const machine = createMachine<
  OnboardPractitionerContext,
  OnboardPractitionerEvent,
  OnboardPractitionerState
>({
  predictableActionArguments: true,
  id: 'onboard_practitioner',
  initial: 'initial',
  context: {
    firstName: '',
    lastName: '',
    phone: '',
    specialty: '',
    practiceType: '',
    primaryBrand: '',
    practiceName: '',
    // newsUpdates: false,
    address: {
      street: [],
      city: '',
      state: '',
      zip: '',
      countryCode: '',
    },
  },
  states: {
    initial: {
      on: {
        '*': [
          {
            cond: ({ customerId }) => Boolean(customerId),
            target: 'complete',
          },
          {
            cond: ({ customerId }) => !customerId,
            target: 'createAccount',
          },
        ],
      },
    },
    createAccount: {
      on: {
        CONTINUE: 'complete',
      },
    },
    invalid: {
      on: {
        RESTORE: 'complete',
      },
    },
    complete: {
      entry: 'submit',
      type: 'final',
    },
  },
  on: {
    UPDATE_FIELDS: {
      actions: assign((context, event) => ({
        ...context,
        ...(event.type === 'UPDATE_FIELDS' ? event.data : {}),
      })),
    },
  },
})

export type OnboardPractitionerMachine = typeof machine

export type OnboardPractitionerInterpreter = InterpreterFrom<OnboardPractitionerMachine>

export type OnboardPractitionerObserverCallback = (state: OnboardPractitionerStateObject) => void

export type OnboardPractitionerStateConfig = StateConfig<
  OnboardPractitionerContext,
  OnboardPractitionerEvent
>

export type OnboardPractitionerStateObject = StateFrom<OnboardPractitionerMachine>

export type OnboardPractitionerStateValue = OnboardPractitionerState['value']
